import styled from 'styled-components'
import { theme } from 'constants/theme'

const DateControl = styled.div`
  text-align: right;
  display: flex;
  flex-direction: column;
  margin: 0;
  justify-content: flex-start;
  height: 92px;

  & div.react-bootstrap-daterangepicker-container {
    z-index: 2;
  }
`

const Frequency = styled.div`
  text-align: right;
  margin-top: 16px;
  width: max-content;
`

const FrequencyButton = styled.button<{ isSelected: boolean }>`
  background: ${({ isSelected }) => (isSelected ? 'var(--color-button-secondary)' :
    theme.tabs.dateButton.color)};
  border: 1px solid ${({ isSelected }) => (isSelected ? 'var(--color-button-secondary)' :
    theme.tabs.dateButton.border)};
  box-sizing: border-box;
  color: ${({ isSelected }) => (isSelected ? 'var(--color-text-on-secondary)' :
    theme.tabs.dateButton.text())};
  padding: 14px 18px;
  text-align: center;
  font-size: 14px;
  outline: none !important;
  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }
  &:last-of-type {
    border-radius: 0 10px 10px 0;
  }
`

export { DateControl, Frequency, FrequencyButton }
